/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * CustomFieldPreferencesDtoBase
 * auto generated base class for the model CustomFieldPreferencesDtoModel.
 */
export const CustomFieldPreferencesDtoModelBase = ModelBase
  .named('CustomFieldPreferencesDto')
  .props({
    __typename: types.optional(types.literal("CustomFieldPreferencesDto"), "CustomFieldPreferencesDto"),
    customFields: types.union(types.undefined, types.array(types.string)),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class CustomFieldPreferencesDtoModelSelector extends QueryBuilder {
  get customFields() { return this.__attr(`customFields`) }
}
export function selectFromCustomFieldPreferencesDto() {
  return new CustomFieldPreferencesDtoModelSelector()
}

export const customFieldPreferencesDtoModelPrimitives = selectFromCustomFieldPreferencesDto().customFields
